import React from "react";
import NavbarFive from "../components/NavbarFive";
import BannerSix from "../components/BannerSix";
import AboutAreaSeven from "../components/AboutAreaSeven";
import ServiceAreaSix from "../components/ServiceAreaSix";
import CaseStudyAreaThree from "../components/CaseStudyAreaThree";
import CounterAreaFive from "../components/CounterAreaFive";
import ContactAreaFive from "../components/ContactAreaFive";
import WorkProcessFive from "../components/WorkProcessFive";
import TeamAreaFour from "../components/TeamAreaFour";
import BlogAreaSix from "../components/BlogAreaSix";
import FooterFive from "../components/FooterFive";

const HomeSeven = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavbarFive />

      {/* Banner Six */}
      <BannerSix />

      {/* About Seven */}
      <AboutAreaSeven />

      {/* Service Area Six */}
      <ServiceAreaSix />

      {/* CaseStudy Area Three */}
      <CaseStudyAreaThree />

      {/* Counter Area Five */}
      <CounterAreaFive />

      {/* Contact Area Five */}
      <ContactAreaFive />

      {/* Work Process Five */}
      <WorkProcessFive />

      {/* Team Area Four */}
      <TeamAreaFour />

      {/* Blog Area Six */}
      <BlogAreaSix />

      {/* Footer Five */}
      <FooterFive />
    </>
  );
};

export default HomeSeven;
